import axios from "axios"

const api = axios.create({
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true
})

export default api